var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"md-avatar d-flex align-items-center",style:([_vm.colorStyle, _vm.shadow ? _vm.shadowStyle : '', _vm.avatarSize])},[_c('span',{staticClass:"mx-auto"},[_vm._v(_vm._s(_vm.username[0] ? _vm.username[0].toUpperCase() : _vm.username.toUpperCase()))])])
}
var staticRenderFns = []

export { render, staticRenderFns }